module.exports = __webpack_public_path__ + "static/media/special_event.d3fb0306.svg";